import { useEffect } from 'react';

import { withEmojiIndex } from 'Shared/utils/withEmojiData';

type Props = {
  emojiIndex?: {
    search: Function;
  };
  setEmojiIndex: Function;
};

function EmojiDataSetter({ emojiIndex, setEmojiIndex }: Props) {
  useEffect(() => {
    setEmojiIndex(emojiIndex);
  }, []);

  return null;
}

export default withEmojiIndex(EmojiDataSetter);
